/**
 * Территории Атырауской области — один список на все экраны планшета.
 *
 * ЗАЧЕМ ОН ПОЯВИЛСЯ. Планшет пришёл из надзорного продукта, где панель смотрела
 * на страну: в фильтрах каждого модуля своим списком лежали города
 * республиканского значения и четырнадцать областей. Панель руководителя
 * ОБЛАСТИ смотрит внутрь своей области, и области страны в её фильтрах
 * читаются как чужие данные — это первое, что замечают на показе.
 *
 * СПИСКОВ БЫЛО СОРОК ТРИ, ПО ОДНОМУ НА МОДУЛЬ, и они уже разъезжались между
 * собой: где-то название с «область», где-то без, и данные под двумя
 * написаниями не сходились. Общий список закрывает и это.
 *
 * ПОРЯДОК — НЕ АЛФАВИТНЫЙ. Первым идёт областной центр, где живёт большая
 * часть населения и случается большая часть событий; дальше районы по убыванию
 * веса. В фильтре человек ищет не букву, а свою территорию.
 */
export const ATYRAU_REGION = "Атырауская область";

/** Значение фильтра «вся область». Отдельной строкой: это не территория. */
export const ATYRAU_ALL = "Вся область";

export const ATYRAU_DISTRICTS = [
  "г. Атырау",
  "Жылыойский район",
  "Курмангазинский район",
  "Махамбетский район",
  "Исатайский район",
  "Индерский район",
  "Макатский район",
  "Кызылкогинский район",
] as const;

export type AtyrauDistrict = (typeof ATYRAU_DISTRICTS)[number];

/**
 * Подпись пункта «вся область» в выпадающих списках.
 *
 * ПОДПИСЬ, А НЕ ЗНАЧЕНИЕ, И ЭТО ВАЖНО. Само значение остаётся `ATYRAU_ALL`
 * («Вся область»): с ним сравнивается сорок с лишним мест по коду
 * (`region !== "Вся область"`), и переименование значения молча превратило бы
 * «всю область» в обычный район — фильтр стал бы искать территорию с таким
 * названием и возвращать пустоту. Так уже было с «Инвесторами и проектами»,
 * см. комментарий к `isWholeOblast` ниже.
 *
 * На экране при этом правильнее «Атырауская область»: список читается как
 * область и её районы, а не как абстрактное «всё».
 */
export const ATYRAU_ALL_LABEL = "Атырауская область";

/** Подпись для любого пункта фильтра: область или район. */
export function atyrauFilterLabel(value: string): string {
  return value === ATYRAU_ALL ? ATYRAU_ALL_LABEL : value;
}

/** Список для выпадающего фильтра: «вся область» плюс территории. */
export const ATYRAU_FILTER_OPTIONS: string[] = [
  ATYRAU_ALL,
  ...ATYRAU_DISTRICTS,
];

/**
 * Короткие имена — для осей диаграмм и узких колонок.
 *
 * Полное «Курмангазинский район» на оси столбиковой диаграммы либо встаёт
 * наискось, либо обрезается многоточием на середине слова; в обоих случаях
 * подпись перестаёт отвечать на вопрос, что за столбик.
 */
export const ATYRAU_DISTRICT_SHORT: Record<string, string> = {
  "г. Атырау": "Атырау",
  "Жылыойский район": "Жылыойский",
  "Курмангазинский район": "Курмангазинский",
  "Махамбетский район": "Махамбетский",
  "Исатайский район": "Исатайский",
  "Индерский район": "Индерский",
  "Макатский район": "Макатский",
  "Кызылкогинский район": "Кызылкогинский",
};

/**
 * Выбрана вся область целиком, а не отдельная территория.
 *
 * ФУНКЦИЯ, А НЕ СРАВНЕНИЕ СО СТРОКОЙ, И ЭТО ИСПРАВЛЕНИЕ РЕАЛЬНОЙ ПОЛОМКИ.
 * Признак «фильтр снят» писался в каждом модуле своей строкой: где-то
 * «Республика», где-то «Все регионы», где-то «Вся область», а глобальный
 * фильтр хранил «Атырауская область». Совпадали они не везде, и экран отбирал
 * данные по территории с несуществующим названием: «Инвесторы и проекты»
 * открывались с нулём проектов при двадцати восьми в наборе, и понять это по
 * экрану было нельзя — ноль выглядел как правда.
 *
 * Старые написания остаются в списке намеренно: они лежат в сохранённых
 * фильтрах и в данных, и выбросить их значит сломать то, что сейчас работает.
 */
export function isWholeOblast(region: string | null | undefined): boolean {
  return (
    !region ||
    region === ATYRAU_ALL ||
    region === ATYRAU_REGION ||
    region === 'Республика' ||
    region === 'Все регионы' ||
    region === 'Вся область'
  )
}
